import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface InactivityDialogProps {
  open: boolean;
  dialogCountdown: number;
  handleStaySignedIn: () => void;
  handleUserLogout: () => void;
}

function InactivityDialog({ open, dialogCountdown, handleStaySignedIn, handleUserLogout }: InactivityDialogProps) {
  return (
    <Dialog open={open}>
      <DialogTitle>Are you still here?</DialogTitle>
      <DialogContent>
        <Typography>
          Your session is about to expire due to inactivity and you will be automatically logged out in{' '}
          <b>{dialogCountdown}</b> second
          {dialogCountdown === 1 ? '' : 's'}. Would you like to continue your session?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUserLogout} variant='text'>
          Log out
        </Button>
        <Button onClick={handleStaySignedIn} color='primary' variant='contained' disableElevation>
          Continue session
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InactivityDialog;
